import { useState } from 'react';
import {
  CurrencyConverterType,
  CurrencyType,
  RealFiatAssets,
} from '@libs/types';

import { CurrencySymbol, SELECTED_FIAT_CURRENCY } from 'src/constants';

export const useCurrencyConverter = (
  defaultCurrency: RealFiatAssets
): CurrencyConverterType => {
  const storageDefaultCurrency = localStorage.getItem(SELECTED_FIAT_CURRENCY);
  const avalibleCurrencies = [CurrencyType.GEL, CurrencyType.USD];

  const defaultSelectedCurrency = avalibleCurrencies.includes(
    storageDefaultCurrency as RealFiatAssets
  )
    ? (storageDefaultCurrency as RealFiatAssets)
    : defaultCurrency;

  const [currency, setCurrency] = useState<RealFiatAssets>(
    defaultSelectedCurrency
  );

  const handleCurrencySelect = (val: RealFiatAssets) => {
    setCurrency(val);
    localStorage.setItem(SELECTED_FIAT_CURRENCY, val);
  };
  return {
    currency,
    setCurrency: handleCurrencySelect,
    currencySymbol: CurrencySymbol[currency],
  };
};
